export enum JobProgressStatus {
    Runnning = 'RUNNING',
    Failed = 'FAILED',
    Finished = 'FINISHED',
    Completed ="COMPLETED"
}
